<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";
	import { Button, Col, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "sveltestrap";
    import type { Diligence } from "../Model/Diligence";
    import { affectedService, complainantService, denouncedService, fileServices, legalGuardianService, pedestrianService, subtypesDiligencesService, witnessService, writeFileService } from "../services";
    import type { Complainant } from "../Model/Complainant";
    import type { Denounced } from "../Model/Denounced";
    import type { Witness } from "../Model/Witness";
    import type { Pedestrian } from "../Model/Pedestrian";
    import type { Affected } from "../Model/Affected";
    import type { LegalGuardian } from "../Model/LegalGuardian";
    import type { SubtypesDiligences } from "../Model/SubtypesDiligences";
    import { error, success } from "../../public/my-theme";
    import { SERVICE_URL } from "../evironment";
    import { getAccessToken } from "../services/session";

	const dispatch = createEventDispatcher();

	let size = 'xl';
	let open = false;
	const delay = (ms: any | undefined) => new Promise(res => setTimeout(res, ms));

	export let diligence: Diligence = null;
    export let formType = null;
    export let policeManifestationInitial = null;
    export let policeManifestationFinish = null;
    export let policeManifestation = null;
    export let pics: any[] = [];

    let files: any[];
    let subtype: SubtypesDiligences;
    let complainants: Complainant[] = [];
    let denounceds: Denounced[] = [];
    let witnesses: Witness[] = [];
    let pedestrians: Pedestrian[] = [];
    let affecteds: Affected[] = [];
    let legalGuardians: LegalGuardian[] = [];

    let diligenceInfo = {}

    let dataLoaded: boolean = false;

    let complainantGroup = 0, denouncedGroup = 0, witnessGroup = 0, pedestrianGroup = 0, affectedGroup = 0, legalGuardianGroup = 0;
    let complainant, denounced, witness, pedestrian, affected, legalGuardian;

    let filesToDownload: any[] = [];

    let picsSelected: any = {
        images: []
    }

	$: open = !!diligence; 
    
    $: if(diligence) loadStatics();
    
	const toggle = () => {
	  size = 'xl';
	  open = !open;
	};

    async function loadStatics() {
        if(diligence) {

            subtype = await subtypesDiligencesService.findOne(diligence.subDiligenceTypeId);

            await loadFiles();

            complainants = await complainantService.findByDiligenceNumber(diligence.id);
            complainants = complainants;
            complainant = complainants.length > 0 ? complainants[0].complainantThirId : undefined;

            denounceds = await denouncedService.findByDiligenceNumber(diligence.id)
            denounceds = denounceds;
            denounced = denounceds.length > 0 ? denounceds[0].denouncedThirId : undefined;

            witnesses = await witnessService.findByDiligenceNumber(diligence.id);
            witnesses = witnesses;
            witness = witnesses.length > 0 ? witnesses[0].witnessThird : undefined;

            pedestrians = await pedestrianService.findByDiligenceNumber(diligence.id);
            pedestrians = pedestrians;
            pedestrian = pedestrians.length > 0 ? pedestrians[0].pedestrianThirId : undefined;

            affecteds = await affectedService.findByDiligenceNumber(diligence.id);
            affecteds = affecteds;
            affected = affecteds.length > 0 ? affecteds[0].affectedThird : undefined;

            legalGuardians = await legalGuardianService.findByDiligenceNumber(diligence.id);
            legalGuardians = legalGuardians;
            legalGuardian = legalGuardians.length > 0 ? legalGuardians[0].representante : undefined

            diligenceInfo = {
                'violenciaGenero': [
                    {
                        name: 'Victimas',
                        data: complainants,
                        third: 'complainantThirId',
                        group: complainantGroup,
                        type: 'complainant'
                    },
                    {
                        name: 'Agresores',
                        data: denounceds,
                        third: 'denouncedThirId',
                        group: denouncedGroup,
                        type: 'denounced'
                    },
                    {
                        name: 'Testigos',
                        data: witnesses,
                        third: 'witnessThird',
                        group: witnessGroup,
                        type: 'witness'
                    }
                ],
                'trafico' : [
                    {
                        name: 'Conductores',
                        data: complainants,
                        third: 'complainantThirId',
                        group: complainantGroup,
                        type: 'complainant'
                    },
                    {
                        name: 'Ocupantes',
                        data: denounceds,
                        third: 'denouncedThirId',
                        group: denouncedGroup,
                        type: 'denounced'
                    },
                    {
                        name: 'Testigos',
                        data: witnesses,
                        third: 'witnessThird',
                        group: witnessGroup,
                        type: 'witness'
                    },
                    {
                        name: 'Peatones',
                        data: pedestrians,
                        third: 'pedestrianThirId',
                        group: pedestrianGroup,
                        type: 'pedestrian'
                    },
                    {
                        name: 'Afectador Colaterales',
                        data: affecteds,
                        third: 'affectedThird',
                        group: affectedGroup,
                        type: 'affected'
                    }
                ],
                'general': [
                    {
                        name: 'Denunciante',
                        data: complainants,
                        third: 'complainantThirId',
                        group: complainantGroup,
                        type: 'complainant'
                    },
                    {
                        name: 'Denunciado',
                        data: denounceds,
                        third: 'denouncedThirId',
                        group: denouncedGroup,
                        type: 'denounced'
                    },
                    {
                        name: 'Testigos',
                        data: witnesses,
                        third: 'witnessThird',
                        group: witnessGroup,
                        type: 'witness'
                    },
                ],
                'acta': [
                    {
                        name: 'Denunciante',
                        data: complainants,
                        third: 'complainantThirId',
                        group: complainantGroup,
                        type: 'complainant'
                    },
                    {
                        name: 'Denunciado',
                        data: denounceds,
                        third: 'denouncedThirId',
                        group: denouncedGroup,
                        type: 'denounced'
                    },
                    {
                        name: 'Testigos',
                        data: witnesses,
                        third: 'witnessThird',
                        group: witnessGroup,
                        type: 'witness'
                    },
                ],
                'perdido': [
                    {
                        name: 'Denunciante',
                        data: complainants,
                        third: 'complainantThirId',
                        group: complainantGroup,
                        type: 'complainant'
                    },
                    {
                        name: 'Denunciado',
                        data: denounceds,
                        third: 'denouncedThirId',
                        group: denouncedGroup,
                        type: 'denounced'
                    },
                    {
                        name: 'Testigos',
                        data: witnesses,
                        third: 'witnessThird',
                        group: witnessGroup,
                        type: 'witness'
                    },
                ]
            }

            if(subtype && subtype.subTypeDiligence === "AUTORIZACION PARA VIAJAR") {
                diligenceInfo[formType].push(
                    {
                        name: 'Representantes Legales',
                        data: legalGuardians,
                        third: 'representante',
                        group: legalGuardianGroup,
                        type: 'legalGuardian'
                    }
                )
            }

            diligenceInfo = diligenceInfo;
            
            dataLoaded = true;
        }
    }

    async function loadFiles() {
        try {

        if(formType == 'violenciaGenero') {
            files = await fileServices.findFilesByContext(diligence.diligenceTypeId)
        }

        if(formType == 'trafico') {
            files = await fileServices.findFilesByContext(diligence.diligenceTypeId)
        }

        if(formType == 'general') {
            files = await fileServices.findFilesByContext(diligence.diligenceTypeId)
        }

        if(formType == 'acta') {
            files = await fileServices.findFilesByContext(diligence.diligenceTypeId)
        }

        if(formType == 'perdido') {
            files = await fileServices.findFilesByContext(diligence.diligenceTypeId)
        }

        } catch(error) {
        console.log(error);
        }
    }

    function addFile(element: any, fileId: any) {
        if(element.checked) {
            filesToDownload.push(fileId);
        } else {
            filesToDownload = filesToDownload.filter(file => file != fileId);
        }

        filesToDownload = filesToDownload;
    }

    async function download() {

        if(filesToDownload.length < 1) {
            error('Debe seleccionar un fichero para descargar.')
        }
        
        if(formType == 'violenciaGenero') {

            filesToDownload.forEach(async (file) => {
                await writeFileService.writeGenderFile(diligence, policeManifestationInitial, policeManifestationFinish, policeManifestation, file, complainant, denounced,witness);
                success('Descarga completada.')
            })
        }

        if(formType == 'trafico') {

            filesToDownload.forEach(async (file) => {
                await writeFileService.writeTrafficFile(diligence, policeManifestationInitial, policeManifestationFinish, policeManifestation, file, complainant, denounced, witness, pedestrian, affected, picsSelected);
                success('Descarga completada.')
            })
        }

        if(formType == 'general') {

            filesToDownload.forEach(async (file) => {
                await writeFileService.writeGeneralFile(diligence, policeManifestationInitial, policeManifestationFinish, policeManifestation, file, complainant, denounced, witness, legalGuardian);
                success('Descarga completada.')
            })
        }

        if(formType == 'acta') {

            filesToDownload.forEach(async (file) => {
                await writeFileService.writeActFile(diligence, policeManifestationInitial, policeManifestationFinish, file, complainant, denounced, witness);
                success('Descarga completada.')
            })
        }

        if(formType == 'perdido') {

            filesToDownload.forEach(async (file) => {
                await writeFileService.writeObjectFile(diligence, policeManifestationInitial, policeManifestationFinish, file, complainant, denounced, witness);
                success('Descarga completada.')
            })
        }
    }

    function addSelected(thirdId, group: string) {
        if(group.includes('complainant')) {
            complainant = thirdId;
        }
        if(group.includes('denounced')) {
            denounced = thirdId;
        }
        if(group.includes('witness')) {
            witness = thirdId;
        }
        if(group.includes('pedestrian')) {
            pedestrian = thirdId;
        }
        if(group.includes('affected')) {
            affected = thirdId;
        }
    }

    function upDateSrc(file: any): string{

        let url = new URL(`/api/files/content/${file.id}` , SERVICE_URL);

        if (SERVICE_URL.includes('localhost') ) {
            url = new URL(`/files/content/${file.id}` , SERVICE_URL);
        }

        url.searchParams.set('access_token', getAccessToken());

        return url.toString();
    }

    function addPic(element: any, file: any) {
        if(element.checked) {
            picsSelected.images.push({src: upDateSrc(file), name: file.name});
        } else {
            picsSelected.images = picsSelected.images.filter(f => f.id != file.id);
        }

        picsSelected = picsSelected;
        console.log(picsSelected)
    }

</script>
  
<Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>Descargar ficheros</ModalHeader>
    <ModalBody>
        {#if dataLoaded}
            <Row>
                <Col xs='12'>
                    <p class='fw-bold mt-3'>Seleccione ficheros para descargar:</p>
                </Col>
                {#if files}
                    {#each files as file}
                        <Col xs='6'>
                            <FormGroup>
                                <Input type="checkbox" label={file.name} on:change={(e) => addFile(e.srcElement, file.id)} />
                            </FormGroup>
                        </Col>
                    {/each}
                {/if}
            </Row>
            <Row>
                <Col>
                    <p class='fw-bold mt-3'>Seleccione los terceros para el documento:</p>
                    <Row>
                        {#each diligenceInfo[formType] as diligenceData}
                            <Col xs='4'>
                                <p class='fst-italic fw-bold'>{diligenceData.name}</p>
                                {#if diligenceData.data.length > 0}
                                    <FormGroup>
                                        {#each diligenceData.data as third, i}
                                            <div class='d-flex gap-3 mb-2'>   
                                                <input 
                                                    checked
                                                    type='radio' 
                                                    id={third[diligenceData.third]}
                                                    value={i}
                                                    bind:group={diligenceData.group}
                                                    on:change={() => addSelected(third[diligenceData.third], diligenceData.type) }
                                                />
                                                <label for={third[diligenceData.third]}>{third.third_name}</label>
                                            </div>
                                        {/each}
                                    </FormGroup>
                                {:else}
                                    <span class='fst-italic'>No hay terceros asignados</span>
                                {/if}
                            </Col>
                        {/each}
                    </Row>
                </Col>
            </Row>
            <!-- <Row>
                <Col xs='12'>
                    <p class='fw-bold mt-3'>Adjuntar imágenes:</p>
                </Col>

                {#if pics && pics.length > 0}
                    {#each pics as pic}
                        <Col xs='4'>
                            <div class='d-flex gap-2 mt-2 p-2 rounded-3 form-check {picsSelected.length > 0 && picsSelected.includes(pic.id) ? 'bg-blue-fill' : 'bg-gray-fill'}'>
                                <input type="checkbox" value={pic.id} on:change={(e) => addPic(e.srcElement, pic)} />
                                <img src={upDateSrc(pic)} alt="" width="200" class='rounded-3 shadow' />
                            </div>
                        </Col>
                    {/each}
                {/if}
            </Row> -->
        {/if}
    </ModalBody>
    <ModalFooter>
        <Button color='success' on:click={download} >Descargar</Button>
    </ModalFooter>
</Modal>

<style>
    .bg-gray-fill {
        background-color: rgb(234, 234, 234);
    }

    .bg-blue-fill {
        background-color: rgba(0, 89, 255, 0.454);
    }
</style>